module.exports = __webpack_public_path__ + "img/slide1.90c1d2cd.jpg";